export enum TranskodeWatermarkVendor {
  NexguardCivolution = "NexguardCivolution",
}
